import { Controller } from '@hotwired/stimulus';

// The results a venue search returns show five at a time, with the rest behind
// a Load More button and a Close that puts them all away again. The js.erb
// response used to bind these by hand after writing the markup in, and bound
// them against the whole document -- so a page carrying two search panels
// wired both to whichever it found first.
export default class extends Controller {
  static targets = ['result', 'extra', 'loadMore', 'actions'];

  loadMore() {
    this.extraTargets.forEach(result => {
      result.style.display = 'flex';
    });
    this.loadMoreTarget.style.display = 'none';
  }

  close() {
    this.resultTargets.forEach(result => {
      result.style.display = 'none';
    });
    this.actionsTarget.style.display = 'none';
  }
}
